import { CurrencyEnum } from '@models/entities/currency'
import { PaymentMethodEnum } from '@models/entities/payment'

export enum TransactionStatusEnum {
  new = 'new',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  mispaid = 'mispaid'
}

export enum TransactionTypeEnum {
  payment = 'payment',
  withdrawal = 'withdrawal',
  refund = 'refund'
}

type TransactionAmountType = {
  currency: CurrencyEnum;
  val: string;
  received?: string;
}

type TransactionStatusType = TransactionStatusEnum.new
  | TransactionStatusEnum.processing
  | TransactionStatusEnum.completed
  | TransactionStatusEnum.failed
  | TransactionStatusEnum.mispaid

type TransactionTypeType = TransactionTypeEnum.payment
  | TransactionTypeEnum.withdrawal
  | TransactionTypeEnum.refund

export type TransactionStatusChipMapType = {
  [key in TransactionStatusEnum]: {
    text: string;
    color: string;
    fontColor: string;
  };
}

export type TransactionTypeTextMapType = {
  [key in TransactionTypeEnum]: string;
}

export enum TransactionFilterEnum {
  point = 'point',
  currency = 'currency',
  method = 'method',
  type = 'type',
  status = 'status',
  updated_date_from = 'updated_date_from',
  updated_date_to = 'updated_date_to',
  amount_from = 'amount_from',
  amount_to = 'amount_to',
  search = 'search',
  user_id_search = 'user_id_search'
}

export enum TransactionDetailsQueryEnum {
  transaction_id = 'transaction_id'
}

export type TransactionsFiltersChip = [TransactionFilterEnum, string]

export enum TransactionReportFormatEnum {
  csv = 'csv',
  xls = 'xls'
}

export type TransactionDetailFieldType = {
  value: string | null;
  source: string | null;
}

export enum TransactionEntryStatusEnum {
  deposit = 'deposit',
  hold = 'hold',
  unhold = 'unhold',
  payout = 'payout',
  cancelled_payout = 'cancelled_payout'
}

export type TransactionEntryType = {
  created_date: string;
  status: TransactionEntryStatusEnum;
  amount: string;
  fee: string;
  charged: string;
}

export type TransactionEntryStatusChipMapType = {
  [key in TransactionEntryStatusEnum]: {
    text: string;
    color: string;
    fontColor: string;
  };
}

export type TransactionDetailsType = {
  first_name?: TransactionDetailFieldType;
  last_name?: TransactionDetailFieldType;
  surname?: TransactionDetailFieldType;
  phone?: TransactionDetailFieldType;
  user_id?: TransactionDetailFieldType;
  email?: TransactionDetailFieldType;
  document_type?: TransactionDetailFieldType;
  document?: TransactionDetailFieldType;
  address?: TransactionDetailFieldType;
  street?: TransactionDetailFieldType;
  country?: TransactionDetailFieldType;
  country_code?: TransactionDetailFieldType;
  city?: TransactionDetailFieldType;
  birth_date?: TransactionDetailFieldType;
  postal_code?: TransactionDetailFieldType;
  state?: TransactionDetailFieldType;
  cpf?: TransactionDetailFieldType;
  iban?: TransactionDetailFieldType;
  user_ip?: TransactionDetailFieldType;
}

export type TransactionType = {
  id: string;
  external_id: string | null;
  created_date: string;
  updated_date: string;
  amount: TransactionAmountType;
  fee: string;
  charged: string;
  point: string;
  status: TransactionStatusType;
  type: TransactionTypeType;
  method: PaymentMethodEnum;
  user_id?: string;
  payer?: TransactionDetailsType;
  postings?: TransactionEntryType[];
}

export const TRANSACTION_DETAILS_FIELDS_ORDER: (keyof TransactionDetailsType)[] = [
  'first_name', 'last_name', 'surname', 'birth_date',
  'email', 'phone', 'user_ip',
  'document_type', 'document', 'cpf', 'iban',
  'country', 'country_code', 'state', 'city', 'postal_code', 'address', 'street'
]

export const TRANSACTION_DETAILS_LABEL_KEYS: Record<keyof TransactionDetailsType, string> = {
  first_name: 'transaction.info.details.first_name.label.text',
  last_name: 'transaction.info.details.last_name.label.text',
  surname: 'transaction.info.details.surname.label.text',
  phone: 'transaction.info.details.phone.label.text',
  user_id: 'transaction.info.details.user_id.label.text',
  email: 'transaction.info.details.email.label.text',
  document_type: 'transaction.info.details.document_type.label.text',
  document: 'transaction.info.details.document.label.text',
  address: 'transaction.info.details.address.label.text',
  street: 'transaction.info.details.street.label.text',
  country: 'transaction.info.details.country.label.text',
  country_code: 'transaction.info.details.country_code.label.text',
  city: 'transaction.info.details.city.label.text',
  birth_date: 'transaction.info.details.birth_date.label.text',
  postal_code: 'transaction.info.details.postal_code.label.text',
  state: 'transaction.info.details.state.label.text',
  cpf: 'transaction.info.details.cpf.label.text',
  iban: 'transaction.info.details.iban.label.text',
  user_ip: 'transaction.info.details.user_ip.label.text'
}
